import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Coming Soon Page Component
 * Displays when a route is not yet implemented
 */
const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="mb-6">
          <div className="inline-block p-4 bg-blue-100 rounded-full">
            <svg
              className="w-16 h-16 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m0 0h6M6 12a6 6 0 11-12 0 6 6 0 0112 0z"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-gray-800 mb-2">
          Coming Soon
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 text-lg mb-8">
          This page is under development and will be available soon. Thank you for your patience!
        </p>

        {/* Features List */}
        <div className="mb-8 bg-white rounded-lg shadow-md p-6 text-left">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">
            What to expect:
          </h3>
          <ul className="space-y-2">
            <li className="flex items-center text-gray-600">
              <span className="text-blue-500 mr-3">✓</span>
              Exciting new features
            </li>
            <li className="flex items-center text-gray-600">
              <span className="text-blue-500 mr-3">✓</span>
              Improved functionality
            </li>
            <li className="flex items-center text-gray-600">
              <span className="text-blue-500 mr-3">✓</span>
              Better user experience
            </li>
          </ul>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full px-6 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-colors"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
